import { BPMN_FORM_REQUESTED,
    BPMN_FORM_RECEIVED,
    BPMN_FORM_ERROR,

    } from "../actions/bpmnForm";
import RequestState from "../storage/RequestState";
import RequestResult from "../storage/RequestResult";
import {EMPTY_REQUEST_RESULT_INIT_STATE} from "../utils/JsObjectHelper";

/**
*
* @param {RequestResult} state
* @param {BaseAction|ReceiveEntryTypesAction|ReceiveErrorAction} action
* @return {RequestResult}
*/
export const bpmnForm = (state = EMPTY_REQUEST_RESULT_INIT_STATE, action)  => {

switch (action.type) {
   case BPMN_FORM_REQUESTED:
       return new RequestResult(RequestState.getInstanceLoading(), state.data);
   case BPMN_FORM_RECEIVED:
       return new RequestResult(RequestState.getInstanceDone(), action.bpmnForm, action.receivedAt);
   case BPMN_FORM_ERROR:
       return new RequestResult(
           RequestState.getInstanceError(
               action.errorResponseStatusCode,
               action.errorResponseMessage ? action.errorResponseMessage : null
           ),
           state.getData()
       );
 
   default:
       return state
}
};
